import React, {useEffect} from "react";
import Block from "./Block";
import gsap from "gsap";

import styles from "./Title.module.scss";

export default function Title({title, numero, background}) {

    useEffect(() => {
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        const titles = document.getElementsByClassName(styles.Main);

        Object.values(titles).map(title =>
            window.addEventListener('scroll', () => {
                const next = title.closest('div').nextElementSibling;

                if (next.getBoundingClientRect().top < vh || next.getBoundingClientRect().bottom > 0 ) {
                    const percent = next.getBoundingClientRect().top * 100 / vh;

                    if (percent < 100 && percent > 0) {
                        gsap.to(title.querySelector('figure'), .3, {
                            scale: 1 +  ((1-(percent * .01)) * 0.1),
                        });

                        gsap.set(title, {
                            y: -(100-percent)
                        });
                    }
                } else {
                    gsap.to(title, .5, {
                        clearProps: 'all'
                    });
                }

            })
        )
    }, []);

    return (
        <div className={styles.TitleWrapper}>
            <Block classname={styles.Main} {...{background}} container={true}>
                <h2 className={styles.Title}>
                    {title}
                </h2>

                <span className={styles.Number}>{numero}.</span>
            </Block>
        </div>
    )
}
